import { __awaiter, __generator } from "tslib";
var Paginator = /** @class */ (function () {
    function Paginator(data, limit, getItems) {
        this._data = data;
        this._limit = limit;
        this._getItems = getItems;
        this._page = -1;
        this._hasMore = true;
    }
    Paginator.prototype._setHasMore = function (status) {
        this._hasMore = status;
    };
    Paginator.prototype.hasMore = function () {
        return this._hasMore;
    };
    Paginator.prototype.hasPrevious = function () {
        return this._page > 0;
    };
    Paginator.prototype.getNextPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._page += 1;
                        return [4 /*yield*/, this._getItems(this._data, this._page, this._limit)];
                    case 1:
                        items = _a.sent();
                        if (items) {
                            this._setHasMore(items.length === this._limit);
                        }
                        else {
                            this._setHasMore(false);
                        }
                        return [2 /*return*/, items];
                }
            });
        });
    };
    Paginator.prototype.getPreviousPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._page -= 1;
                        return [4 /*yield*/, this._getItems(this._data, this._page, this._limit)];
                    case 1:
                        items = _a.sent();
                        this._setHasMore(true);
                        return [2 /*return*/, items];
                }
            });
        });
    };
    Paginator.prototype.getPage = function (page) {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getItems(this._data, page, this._limit)];
                    case 1:
                        items = _a.sent();
                        this._setHasMore(items.length === this._limit);
                        this._page = page;
                        return [2 /*return*/, items];
                }
            });
        });
    };
    return Paginator;
}());
export { Paginator };
//# sourceMappingURL=Paginator.js.map